import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import { report_quotation, report_deposit, report_loan } from "../../../components/Report.js";
export default class OrderLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_detail: false,

      filter_search: "",
      filter_start_date: "",
      filter_end_date: "",
      filter_warehouse_id: "",
      filter_payment_type: "ชำระเงินทันที,ชำระมัดจำ",
      filter_status: "รอชำระ,รอสั่งสินค้า,ยกเลิก",

      data: [],
      count: 10,
      data_warehouse: [],

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      account_name: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_payment_type,
      filter_status,
    } = this.state;
    let data, count, data_warehouse;
    loading(true);
    let [result, result_warehouse] = await Promise.all([
      GET("admin/sales/list", {
        page: page,
        data_search: filter_search,
        start_date: filter_start_date,
        end_date: filter_end_date,
        warehouse_id: filter_warehouse_id,
        payment_type: filter_payment_type,
        status_code: filter_status,
        withdrawal_type: "ขายหน้าร้าน,รอสั่งสินค้า"
      }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    this.setState({
      data,
      count,
      data_warehouse,
    });
    loading(false);
  };
  Update = async (uid) => {
    if (
      await alert(
        "",
        "info",
        "ยืนยัน",
        'ยืนยันการเปลี่ยนสถานะจาก "รอสั่งงซื้อสินค้า" เป็น "รอชำระเงิน" หรือไม่',
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let body = {
        status: "รอชำระ",
      };

      let result = await PUT("admin/sales/update/" + uid, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
        );
      }
      loading(false);
    }
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "ยกเลิก",
        "ยืนยันรายการนี้หรือไม่ ?",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);

      let body = {
        status: "ยกเลิก",
      };

      let result = await PUT("admin/sales/update/" + id, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
        );
      }
      loading(false);
    }
  };
  gotoPayment = (item) => {
    if(profile?.user_type !== "technical"){
      if (["รอชำระ", "รอสั่งสินค้า","ยกเลิก"].includes(item.status) && item.withdrawal_type !== "เบิกแจ้งซ่อม") {
        window.location.href = "/payment/payments?id=" + item.uid + (item.status === "ยกเลิก" ? "&type=view" : "&type=create");
      }
    }
  };
  render() {
    const {
      modal_detail,
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_payment_type,
      filter_status,
      data,
      count,
      data_warehouse,
      id,
      uid,
      bank_name,
      account_number,
      account_name,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายการขายสินค้า</h4>
               <div className="border-1 border-secondary rounded-4 p-1 d-flex bg-light mb-3">
                              <button
                                className={`btn ${
                                  ["", "ชำระเงินทันที", "ชำระมัดจำ","ชำระเงินทันที,ชำระมัดจำ"].includes(filter_payment_type) ? "btn-dark" : "btn-light"} px-3`}
                                onClick={async () => {
                                  this.setState({
                                    filter_payment_type: "ชำระเงินทันที,ชำระมัดจำ",
                                  },() => {this.Get(1);});
                                }}
                              >
                                ชำระทันที & มัดจำ
                              </button>
                              <div style={{ width: 4 }}></div>
                              <button
                                className={`btn ${
                                  filter_payment_type === "ชำระเงินเชื่อ" ? "btn-dark" : "btn-light"
                                } px-3`}
                                onClick={async () => {
                                  this.setState({
                                    filter_payment_type: "ชำระเงินเชื่อ",
                                  },() => {this.Get(1);});
                                }}
                              >
                                ชำระเงินเชื่อ
                              </button>
                            </div>
            </div>
            <div className="d-flex align-items-center flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="บิลขาย, ชื่อลูกค้า, เบอร์โทร..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              {filter_payment_type !== "ชำระเงินเชื่อ"  && (
              <select
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_payment_type: e.target.value });
                }}
                value={filter_payment_type}
              >
                <option value="ชำระเงินทันที,ชำระมัดจำ">รูปแบบการชำระเงิน</option>
                <option value="ชำระเงินทันที">ชำระเงินทันที</option>
                <option value="ชำระมัดจำ">ชำระมัดจำ</option>
              </select>
              )}
              <select
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_status: e.target.value });
                }}
                value={filter_status}
              >
                <option value="รอชำระ,รอสั่งสินค้า,ยกเลิก,คืนสินค้า">สถานะ</option>
                <option value="รอชำระ">รอชำระ</option>
                <option value="รอสั่งสินค้า">รอสั่งสินค้า</option>
                <option value="ยกเลิก">ยกเลิก</option>
                <option value="คืนสินค้า">คืนสินค้า</option>
              </select>
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="คลังสินค้า..."
                  options={data_warehouse}
                  onChange={(e) => {
                    this.setState({ filter_warehouse_id: e });
                  }}
                  value={filter_warehouse_id}
                />
              </div>
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">วันที่เอกสาร</td>
                    <td className="text-nowrap">เลขที่เอกสาร</td>
                    <td className="text-nowrap">ลูกค้า</td>
                    <td className="text-nowrap">คลังสินค้า</td>
                    <td className="text-nowrap text-end">ยอดรวม</td>
                    <td className="text-nowrap text-end">ค่ามัดจำ</td>
                    <td className="text-nowrap text-end">ชำระบางส่วน</td>
                    <td className="text-nowrap text-end">ค้างชำระ</td>
                    <td className="text-nowrap text-center">รูปแบบการชำระ</td>
                    <td className="text-nowrap text-center">สถานะ</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td
                        className="text-nowrap"
                        onClick={() => {
                          this.gotoPayment(item);
                        }}
                      >
                        {" "}
                        {item.created_at
                          ? format_date(item.created_at, "dd/mm/yyyy hh:mm น.")
                          : ""}
                      </td>
                      <td
                        className="text-nowrap"
                        onClick={() => {
                          this.gotoPayment(item);
                        }}
                      >
                        {" "}
                        {item.document_no}
                      </td>
                      <td
                        className="text-nowrap"
                        onClick={() => {
                          this.gotoPayment(item);
                        }}
                      >
                        {" "}
                        {item.customer?.full_name || "-"}
                      </td>
                      <td
                        className="text-nowrap"
                        onClick={() => {
                          this.gotoPayment(item);
                        }}
                      >
                        {" "}
                        {item.warehouse?.name || "-"}
                      </td>
                      <td
                        className="text-nowrap text-end"
                        onClick={() => {
                          this.gotoPayment(item);
                        }}
                      >
                        {" "}
                        {toFixed(item.amount) || "0.00"}
                      </td>
                      <td
                        className="text-nowrap text-end"
                        onClick={() => {
                          this.gotoPayment(item);
                        }}
                      >
                        {" "}
                        {toFixed(item.amount_deposit) || "-"}
                      </td>
                      <td
                        className="text-nowrap text-end"
                        onClick={() => {
                          this.gotoPayment(item);
                        }}
                      >
                        {" "}
                        {toFixed(Number(item.total_pay)) || "-"}
                      </td>
                      <td
                        className={`text-nowrap text-end ${
                          Number(item.amount) + Number(item.vat) - (Number(item.total_pay)) - Number(item.amount_deposit) !==
                          0
                            ? Number(item.total_pay) !== 0
                              ? "text-warning"
                              : "text-danger"
                            : "text-dark"
                        }`}
                        onClick={() => {
                          this.gotoPayment(item);
                        }}
                      >
                        {" "}
                        {toFixed((Number(item.amount) + Number(item.vat) - Number(item.discount)) - (Number(item.total_pay)))}
                      </td>
                      <td
                        className="text-nowrap text-center"
                        onClick={() => {
                          this.gotoPayment(item);
                        }}
                      >
                        {" "}
                        {item.payment_type || "-"}
                      </td>
                      <td
                        className="text-nowrap text-center"
                        onClick={() => {
                          this.gotoPayment(item);
                        }}
                      >
                        {" "}
                        {item.status || "-"}
                      </td>
                      <td className="text-center align-middle wpx-100">
                        <div className="d-flex">
                          {item.status === "รอชำระ" && (
                            <BtnIcon
                            className="order-lists.delete"
                              type="delete"
                              onClick={() => {
                                this.Delete(item.uid);
                              }}
                            />
                          )}
                          <BtnIcon
                            type="print"
                            onClick={() => {
                               Swal.fire({
                                        title: "พิมพ์เอกสาร",
                                        text: "",
                                        html:`
                                          <div class="w-100">
                                            <button id="btn-report-quotation" class="btn btn-outline-dark w-100 mb-3 text-start">
                                              <span class="icon me-2">&#xf15b;</span>
                                              ใบเสนอราคา
                                            </button>
                                            <button id="btn-report-deposit" class="btn btn-outline-dark w-100 mb-3 text-start">
                                              <span class="icon me-2">&#xf15b;</span>
                                              ใบมัดจำสินค้า
                                            </button>
                                            <button id="btn-report-loan" class="btn btn-outline-dark w-100 mb-3 text-start">
                                              <span class="icon me-2">&#xf15b;</span>
                                              ใบยืมสินค้า
                                            </button>
                                          </div>
                                        `,
                                        showConfirmButton: false,
                                        showCancelButton: false,
                                        showCloseButton: true,
                                        didOpen: () => {
                                          document.getElementById("btn-report-quotation").addEventListener("click", () => {report_quotation(item.uid);});
                                          document.getElementById("btn-report-deposit").addEventListener("click", () => {report_deposit(item.uid);});
                                          document.getElementById("btn-report-loan").addEventListener("click", () => {report_loan(item.uid);});
                                        },
                                      });
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
      </div>
    );
  }
}
